module.exports = __webpack_public_path__ + "static/media/Laidley Street, San Francisco, CA9.dc13e0c4.jpg";